module.exports = __webpack_public_path__ + "3.8c10eab0.png";